<script setup lang="ts">
// Mounts the global overlays: login dialog, discussion-group QR and the first-visit notice.
import AuthModal from './AuthModal.vue'
import ContactQrModal from './ContactQrModal.vue'
import NoticePopup from './NoticePopup.vue'
import { overlays } from '../stores/overlays'
import './overlays.css'
</script>

<template>
  <AuthModal v-if="overlays.auth" :mode="overlays.auth.mode" :method="overlays.auth.method" :message="overlays.auth.message" />
  <ContactQrModal v-if="overlays.contact" />
  <NoticePopup />
</template>
